import React from "react";

/**
 * Subtle film-grain texture overlay.
 *
 * Drop into any *relatively-positioned* dark section to break the flat-web
 * feel. Uses an inline SVG turbulence filter (no network round-trip) and
 * `mix-blend-overlay` so the grain is visible on dark and invisible on
 * light surfaces — same component, polite on both themes.
 *
 * Usage:
 *   <section className="relative bg-ink overflow-hidden">
 *     <NoiseOverlay />
 *     ...content...
 *   </section>
 */
export const NoiseOverlay = ({ opacity = 0.06, className = "" }) => (
  <div
    aria-hidden="true"
    data-testid="luxury-noise-overlay"
    className={`pointer-events-none absolute inset-0 luxury-grain mix-blend-overlay ${className}`}
    style={{ opacity }}
  />
);

export default NoiseOverlay;
